import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import swal from "sweetalert";
import { Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function IpfsGenerator(props) {
  const [nftDetails, setNftDetails] = React.useState({
    name: "",
    description: "",
    image: "",
  });
  const [ipfsUrl, setIpfsUrl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  function handleNftDetailsForm(e) {
    const { name, value } = e.target;

    setNftDetails((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  }

  async function handleIpfsImage(event) {
    const file = event.target.files[0];

    let data = new FormData();
    data.append("file", file);
    if (file) {
      setLoading(true);
      await axios({
        method: "post",
        url: "https://ipfs.hascoin.io/uploadFileToIpfs",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      })
        .then((response) => {
          const ipfsUrl =
            "https://ipfs.hascoin.io/ipfs/" + response.data[0].hash;
          setNftDetails({ ...nftDetails, image: ipfsUrl });
        })
        .catch((err) => {
          swal({
            text: "Something Went Wrong",
            icon: "error",
          });
        });
      setLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (nftDetails.name && nftDetails.description && nftDetails.image) {
      setLoading(true);
      await axios({
        method: "post",
        url: "https://ipfs.hascoin.io/uploadJsonToIpfs",
        data: nftDetails,
        headers: {
          "content-type": "application/json",
        },
      })
        .then((response) => {
          const ipfsUrl =
            "https://ipfs.hascoin.io/ipfs/" + response.data[0].hash;
          setIpfsUrl(ipfsUrl);
        })
        .catch((err) => {
          swal({
            text: "Something Went Wrong",
            icon: "error",
          });
        });
      setLoading(false);
    } else {
      swal({
        text: "Select NFT image first!",
        icon: "warning",
      });
    }
  }
  const [isCopy, setIsCopy] = React.useState(false);

  function saveToClipboard(url) {
    navigator.clipboard.writeText(url);
    setIsCopy(true);
  }

  function handleHover() {
    setIsCopy(false);
  }

  function handleClose() {
    setIpfsUrl(null);
    setNftDetails({
      name: "",
      description: "",
      image: "",
    });
    props.handleClose();
  }

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle style={{ fontFamily: "Poppins", color: "rgb(0, 30, 43)" }}>
          Generate IPFS
        </DialogTitle>
        {!ipfsUrl ? (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <DialogContentText mb={"12px"} style={{ fontFamily: "Poppins" }}>
                Please complete all the NFT information to generate the IPFS
                URL.
              </DialogContentText>

              <fieldset className="login-form input-fullwidth">
                <label id="imageLabel" className="login-form-label">
                  NFT Image <span className="required-field">*</span>
                  <div className="input-div-css-1 input-fullwidth input-div-css-2">
                    <div className="input-div-css-3">
                      <input
                        name="image"
                        aria-labelledby="imageLabel"
                        type="file"
                        className="input-custom-css"
                        id="image"
                        aria-invalid="false"
                        accept="image/png,image/jpeg,image/gif,image/svg+xml"
                        hidden
                        onChange={(e) => handleIpfsImage(e)}
                      />
                      <label id="nft-image-btn" htmlFor="image">
                        {nftDetails.image ? (
                          <img
                            alt="image"
                            width={298}
                            height={148}
                            src={nftDetails.image}
                            style={{ objectFit: "contain" }}
                          />
                        ) : (
                          <div id="nft-image-text">+</div>
                        )}
                      </label>
                    </div>
                  </div>
                </label>
              </fieldset>
              <fieldset className="login-form input-fullwidth">
                <label
                  htmlFor="name"
                  id="nameLabel"
                  className="login-form-label"
                >
                  NFT Name <span className="required-field">*</span>
                  <div className="input-div-css-1 input-fullwidth input-div-css-2">
                    <div className="input-div-css-3">
                      <input
                        required
                        name="name"
                        aria-labelledby="nameLabel"
                        type="text"
                        className="input-custom-css input-custom-height"
                        id="name"
                        aria-invalid="false"
                        value={nftDetails.name}
                        onChange={(e) => handleNftDetailsForm(e)}
                      ></input>
                    </div>
                  </div>
                </label>
              </fieldset>
              <fieldset className="login-form input-fullwidth">
                <label
                  htmlFor="description"
                  id="descriptionLabel"
                  className="login-form-label"
                >
                  NFT Description <span className="required-field">*</span>
                  <div className="input-div-css-1 input-fullwidth input-div-css-2">
                    <div className="input-div-css-3">
                      <input
                        required
                        name="description"
                        aria-labelledby="descriptionLabel"
                        type="text"
                        className="input-custom-css input-custom-height"
                        id="description"
                        aria-invalid="false"
                        value={nftDetails.description}
                        onChange={(e) => handleNftDetailsForm(e)}
                      ></input>
                    </div>
                  </div>
                </label>
              </fieldset>
            </DialogContent>
            <DialogActions>
              <Button
                className="custom-color-button"
                sx={{
                  fontSize: "15px",
                }}
                onClick={handleClose}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                disabled={loading}
                className="custom-color-button"
                sx={{
                  fontSize: "15px",
                }}
                type="submit"
                variant="contained"
              >
                Generate
              </Button>
            </DialogActions>
          </form>
        ) : (
          <DialogContent>
            <DialogContentText mb={"12px"} style={{ fontFamily: "Poppins" }}>
              Please copy the IPFS URL and paste it into your argument where it
              is required.
            </DialogContentText>
            <DialogContent>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Typography
                  noWrap={true}
                  style={{
                    border: "1px solid rgb(136, 147, 151)",
                    verticalAlign: "middle",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                >
                  {ipfsUrl}
                </Typography>
                <div
                  style={{
                    marginLeft: "6px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Tooltip
                    className="addButton"
                    fontSize="large"
                    title={isCopy ? "Copied" : "Copy link"}
                  >
                    <ContentCopyIcon
                      style={{ display: "block", margin: "auto" }}
                      onMouseLeave={handleHover}
                      onClick={() => saveToClipboard(ipfsUrl)}
                    />
                  </Tooltip>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                className="custom-color-button"
                sx={{
                  fontSize: "15px",
                }}
                onClick={handleClose}
                variant="contained"
              >
                Close
              </Button>
            </DialogActions>
          </DialogContent>
        )}
      </Dialog>
    </div>
  );
}
